import * as React from "react";
import type { SVGProps } from "react";
const SvgQuestionMarkInSquare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M11.99 15c-.55 0-1-.45-1-1v-1.32c0-.55.46-1 1.01-1 .49 0 .95-.19 1.3-.54.35-.35.54-.81.54-1.3s-.19-.95-.54-1.3c-.7-.7-1.91-.69-2.6 0a.996.996 0 1 1-1.41-1.41c1.45-1.45 3.98-1.45 5.43 0 .73.73 1.12 1.69 1.12 2.72 0 1.03-.4 1.99-1.12 2.72-.48.48-1.07.82-1.71 1v.45c0 .55-.45 1-1 1l-.02-.02ZM12 18c-.26 0-.52-.11-.71-.29-.18-.19-.29-.44-.29-.71 0-.27.11-.52.29-.71a1.037 1.037 0 0 1 1.42 0c.18.19.29.45.29.71 0 .07 0 .13-.02.2 0 .06-.03.12-.06.18-.02.06-.05.12-.09.18-.02.033-.049.067-.078.1l-.042.05c-.19.18-.45.29-.71.29Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2 18c0 2.21 1.79 4 4 4h12c2.21 0 4-1.79 4-4V6c0-2.21-1.79-4-4-4H6C3.79 2 2 3.79 2 6v12ZM4 6c0-1.1.9-2 2-2h12c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H6c-1.1 0-2-.9-2-2V6Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgQuestionMarkInSquare;
